import React, { useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/subject-outcomes/SubjectOutcomesAction";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { SubjectOutcomeEditForm } from "./SubjectOutcomeEditForm";

export function SubjectOutcomeEdit({
  history,
  match: {
    params: { page, id, subjectId, courseId }
  }
}) {
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, subjectOutcome } = useSelector(
    (state) => ({
      actionsLoading: state.subjectOutcomes.actionsLoading,
      isSuccess: state.subjectOutcomes.isSuccess,
      type: state.subjectOutcomes.type,
      subjectOutcome: state.subjectOutcomes.subjectOutcome
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getsubjectOutcome(id, subjectId));
    return () => dispatch(actions.cleanSubjectOutcomesState())
  }, [id, subjectId, dispatch]);
  
  const saveSubjectOutcome = (values) => {
    dispatch(actions.saveSubjectOutcome(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);

    if (isSuccess) {
      setTimeout(() => {
        if (page === "ogretmen") history.push(`/ogretmen/konu-kazanimlari/${subjectId}/${courseId}`);
        else history.push(`/konu-kazanimlari/${subjectId}/${courseId}`);
      }, 2500);
    }
  };

  const btnRef = useRef();  
  const saveSubjectOutcomeClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  let title = "Konu Kazanımı";
  let action = id ? "Düzenle" : "Ekle";
  title += " " + action;
  title = <>{title} (Konu: <span style={{color:"red"}}>{subjectOutcome.subject}</span>) (Ders: <span style={{color:"red"}}>{subjectOutcome.course}</span>)</>

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <SubjectOutcomeEditForm 
            subjectOutcome={subjectOutcome}
            btnRef={btnRef} 
            saveSubjectOutcome={saveSubjectOutcome}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveSubjectOutcomeClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}